<template>
    <div class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 1">
        <PublicOfferRu/>
    </div>
    <div class="delivery-sec__body" v-if="this.$store.state.settings.site_id === 2">
        <PublicOfferEn/>
    </div>


</template>

<script>
import PublicOfferRu from './ru/public-offer.vue'
import PublicOfferEn from './en/public-offer.vue'
export default {
    components:{
        PublicOfferRu,PublicOfferEn
    },
    name: "public-offer"
}
</script>

<style scoped>

</style>
